export function calcProgressPercent(units: number, goal: number): number {
  return goal > 0 ? Math.round((units / goal) * 100) : 0;
}
